import React from "react";
import { MapIcon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../ui/CtaButton";
import { Countdown } from "../ui/Countdown";
export function HeroSection() {
  return <header className="bg-cream px-5 pb-14 pt-8 sm:pt-12" data-id="element-140" data-mp="2191ipnws7c0y">
      <div className="mx-auto max-w-5xl text-center" data-id="element-141" data-mp="1x91525hib4uy">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-142" data-mp="1x87suozs3n5f">
          <span className="flex items-center gap-2" data-id="element-143" data-mp="1sapu1rfh6ob5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-navy text-cyan" data-id="element-144" data-mp="1sbhd62rvytkj">
              <MapIcon className="h-5 w-5" aria-hidden="true" data-id="element-145" data-mp="1ijuwvs0oy4ax" />
            </span>
            <span className="font-display text-xl font-bold text-ink" data-id="element-146" data-mp="1ihs9lfqxap9w">Endo Blueprint™</span>
          </span>
          <span className="rounded-full border border-line bg-paper px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-navy" data-id="element-147" data-mp="1dixh1m35lmcl">
            Endodontic Master Map™
          </span>
        </div>

        <h1 className="mt-7 font-display text-[2.15rem] font-extrabold leading-[1.08] text-ink sm:text-6xl" data-id="element-148" data-mp="14mg5ihqvnmgb">
          Organize Your Endodontic Case in{" "}
          <em className="whitespace-nowrap font-extrabold italic text-cyan" data-id="element-149" data-mp="36fmfa2i24okx">15 Minutes</em> With a Clear, Step-by-Step
          Clinical Framework
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-xl" data-id="element-150" data-mp="2worpio5lr6uq">
          A practical visual system designed to help you organize the information available, identify what needs further
          evaluation, connect the key concepts of endodontics, and structure your next clinical questions—
          <strong className="text-ink" data-id="element-151" data-mp="3bcw35dpsss6n">all in one place.</strong>
        </p>

        <div className="-mx-5 mt-6 sm:mx-auto sm:max-w-3xl" data-id="element-152" data-mp="3gcipqdrinks4">
          <img src={images.hero} alt="Endo Blueprint collection: 6 volumes, master map, worksheets and tablet version" className="w-full" data-id="element-153" data-mp="3gf4wwcahvy9t" />
        </div>

        <p className="mx-auto mt-2 max-w-2xl text-[15px] font-semibold text-ink sm:text-lg" data-id="element-154" data-mp="24vsfmjjz28t8">
          <span className="text-cyan" data-id="element-155" data-mp="ajrapttqimfj">6 Premium Volumes.</span> 5 Professional Bonuses. Clinical Decision Maps. Case
          Analysis Worksheets. Checklists.
        </p>

        <div className="mt-7" data-id="element-156" data-mp="qitshpq0cn2">
          <CtaButton id="hero-cta" label="Get the Endo Blueprint™" data-id="element-157" data-mp="pqxf4oauavq" />
          <p className="mt-4 text-sm text-muted" data-id="element-158" data-mp="3suuv71y0yfd0">
            Instant Digital Access · One-Time Payment of <strong className="text-ink" data-id="element-159" data-mp="3nxchky92bbyo">$27 USD</strong> · Lifetime Access
            · 7-Day Guarantee
          </p>
          <Countdown data-id="element-160" data-mp="3iw59sz6x6cs0" />
        </div>
      </div>
    </header>;
}